<template>
  <div class="guest-summary">
    <div class="summary-header d-flex align-center mb-2 flex-wrap">
      <div class="main-title mr-6">{{ $t("kiosk_status") }}</div>
    </div>
    <div class="content">
      <template v-if="false">
        <div class="printer">
          <v-skeleton-loader class="place" type="text" height="12px" width="40px" />
          <v-skeleton-loader class="status" type="heading" height="24px" width="120px" />
          <v-skeleton-loader class="note" type="text" height="12px" width="190px" />
        </div>
      </template>
      <h3>{{ $t("cash_levels") }}</h3>
      <div class="kiosk-list">
        <div class="kiosk-item" v-for="[name, kiosk] in cashLevels" :key="name">
          <h4 class="kiosk-name">{{ $t('kiosk_name', { name }) }}</h4>
          <table class="table">
            <thead>
              <tr class="table-header">
                <th>{{ $t('denomination') }}</th>
                <th>{{ $t('denomination_count') }}</th>
              </tr>
            </thead>
            <tbody>
            <template v-if="kiosk.banknotes.length">
              <tr>
                <th class="table-subheader">{{ $t('banknotes') }}</th>
              </tr>
              <tr v-for="item in kiosk.banknotes" :key="item.denomination" class="table-row">
                <th>
                    <span>
                      {{ $t(`currency_symbols.${item.currencyCode}`) }}{{ item.denomination / 100 }}
                    </span>
                </th>
                <th>{{ item.count }}</th>
              </tr>
            </template>
            <template v-if="kiosk.coins.length">
              <tr>
                <th class="table-subheader">{{ $t('coins') }}</th>
              </tr>
              <tr v-for="item in kiosk.coins" :key="item.denomination" class="table-row">
                <th>
                  <span>
                    {{ $t(`currency_symbols.${item.currencyCode}`) }}{{ item.denomination / 100 }}
                  </span>
                </th>
                <th>{{ item.count }}</th>
              </tr>
            </template>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from 'qs';
import { base } from '@/axios-api';


export default {
  name: "CashKioskStatus",
  data() {
    return {
      kiosksData: null,
    };
  },
  props: {
    place: {
      default: 0,
    },
  },
  methods: {
    getKiosksData() {
      base({
        url: '/kiosks/cash-levels',
        method: 'GET',
        params: {
          place_id: this.place,
        },
        paramsSerializer: params => {
          return qs.stringify(params, {
            arrayFormat: 'repeat'
          })
        },
      })
        .then((response) => {
          this.kiosksData = response.data;
        });
    },
    handlePublication(push) {
      if (push?.data?.event === `kiosk.cash_levels.updated`) {
        this.kiosksData = {
          ...this.kiosksData,
          cashLevels: {
            ...this.kiosksData.cashLevels,
            ...push.data.content,
          }
        }
      }
    },
  },
  computed: {
    cashLevels() {
      if (!this.kiosksData) {
        return [];
      }
      return Object.entries(this.kiosksData.cashLevels)
    },
  },
  created() {
    this.getKiosksData();
  },
};
</script>

<style scoped lang="scss">
.summary-header {
  width: 90%;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.kiosk-list {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
}

.kiosk-name {
  color: $green-lightened
}

.table {
  text-align: left;
  border-spacing: 10px 2px;
  border-collapse: separate;
  margin: -2px -10px;
  margin-top: 0;
  text-wrap: nowrap;

  th:first-child {
    min-width: 100px;
  }
}

.table-header th {
  font-size: 18px;
  font-weight: 700;
}

.table-subheader {
  font-size: 14px;
  color: #909494;
}

.table-row {
  th {
    font-size: 16px;
    font-weight: 400;

    &:first-child {
      background-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="3" height="3"><circle r="1" fill="%23888" /></svg>');
      background-position-y: 60%;
      background-repeat: repeat-x;
      width: 100%;
    }

    span {
      background-color: white;
      padding-right: 10px;
    }
  }
}

.place {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
}

.status {
  margin: 0;
  margin-top: 10px;
  color: $green-darkened;
  font-size: 24px;
  font-weight: 700;
  line-height: 18px;

  &.warning {
    color: $error-orange;
  }

  &.error {
    color: $error-darkened;
  }
}
</style>
